module.exports = __webpack_public_path__ + "static/media/avatar_active.063b716d.svg";